var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrademarks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.5,
    height: 19.496,
    viewBox: "0 0 19.5 19.496",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_1718",
    "data-name": "Group 1718",
    transform: "translate(-840.149 -5214.464)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2046",
    "data-name": "Path 2046",
    d: "M858.9,5224.211a9,9,0,1,1-9-9A9,9,0,0,1,858.9,5224.211Z",
    transform: "translate(0 0)",
    fill: "#E4EAFF",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "T",
    transform: "translate(840.138 5214.641)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1717",
    "data-name": "Group 1717",
    style: {
      isolation: "isolate"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2188",
    "data-name": "Path 2188",
    d: "M12.146,6.394V7.4H10.391v5.346H9.122V7.4H7.376V6.394Z",
    fill: "#000000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrademarks);
export default __webpack_public_path__ + "static/media/Trademarks.871eeeb77e4a5e899907ca39dfbcb5b5.svg";
export { ForwardRef as ReactComponent };